import { createSlice } from '@reduxjs/toolkit'

export const LoginSessionSlice = createSlice({
  name: 'loginSession',
  initialState: {
    value: "",
    initPendo : false
  },
  reducers: {
    loginSessionDetail: (state, action) => {
      state.value = action.payload;
      state.initPendo = true;//initialize the pendo after user login
    },
    initializePendo: (state, action) => {
        state.initPendo = action.payload;
    },
  },
})

export const { loginSessionDetail, initializePendo } = LoginSessionSlice.actions

export default LoginSessionSlice.reducer